var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogistic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3548 6.25H9.89648C9.03354 6.25 8.33398 6.94956 8.33398 7.8125V14.0625C8.33398 14.9254 9.03354 15.625 9.89648 15.625H21.3548C22.2178 15.625 22.9173 14.9254 22.9173 14.0625V7.8125C22.9173 6.94956 22.2178 6.25 21.3548 6.25Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.375V12.5M18.75 9.375V12.5",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7507 6.25V3.125H12.5007V6.25M22.9173 18.75H6.25065C5.97438 18.75 5.70943 18.6403 5.51408 18.4449C5.31873 18.2496 5.20898 17.9846 5.20898 17.7083V5.72917C5.20898 5.4529 5.09924 5.18795 4.90389 4.9926C4.70854 4.79725 4.44358 4.6875 4.16732 4.6875H2.08398M9.89648 21.875C9.48208 21.875 9.08466 21.7104 8.79163 21.4174C8.4986 21.1243 8.33398 20.7269 8.33398 20.3125V18.75H11.459V20.3125C11.459 20.7269 11.2944 21.1243 11.0013 21.4174C10.7083 21.7104 10.3109 21.875 9.89648 21.875ZM19.2715 21.875C18.8571 21.875 18.4597 21.7104 18.1666 21.4174C17.8736 21.1243 17.709 20.7269 17.709 20.3125V18.75H20.834V20.3125C20.834 20.7269 20.6694 21.1243 20.3763 21.4174C20.0833 21.7104 19.6859 21.875 19.2715 21.875Z",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistic);
export default __webpack_public_path__ + "static/media/logistic.2acbdb45bac7083a8d783e64ac3f7bba.svg";
export { ForwardRef as ReactComponent };